import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRemoveBackground2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconRemoveBackground2"><Path fillRule="evenodd" clipRule="evenodd" d="M13 3H21V21H13V23H11V21H3V3H11V1H13V3ZM8 8H5V12H8V16H5V19H8V16H11V12H8V8H11V5H8V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRemoveBackground2;
